var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_8860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 7.50247C7.49956 7.35459 7.53848 7.20924 7.61277 7.08136C7.68705 6.95349 7.79403 6.84768 7.92272 6.77481C8.05141 6.70194 8.19718 6.66463 8.34505 6.66671C8.49293 6.66879 8.63758 6.71018 8.76417 6.78664L12.9283 9.28414C13.0523 9.35803 13.155 9.46285 13.2263 9.58833C13.2975 9.71381 13.335 9.85565 13.335 9.99997C13.335 10.1443 13.2975 10.2861 13.2263 10.4116C13.155 10.5371 13.0523 10.6419 12.9283 10.7158L8.76417 13.2133C8.63752 13.2898 8.49279 13.3312 8.34484 13.3332C8.1969 13.3353 8.05107 13.2979 7.92236 13.2249C7.79364 13.152 7.68667 13.046 7.61245 12.918C7.53822 12.79 7.49941 12.6446 7.50001 12.4966V7.50247Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3334C14.6023 18.3334 18.3333 14.6024 18.3333 10C18.3333 5.39765 14.6023 1.66669 9.99996 1.66669C5.39759 1.66669 1.66663 5.39765 1.66663 10C1.66663 14.6024 5.39759 18.3334 9.99996 18.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_8860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeRecording);
export default __webpack_public_path__ + "static/media/resume_recording.73c6802dd6236461b9dce7d677529719.svg";
export { ForwardRef as ReactComponent };